<template>
    <div class="page-main" :style="dataDetailStyle">
        <dt-search-bar style="padding:20px 5px 5px;">
            <template slot="filterSlot">
                <data-filter
                        ref="dataFilterRef"
                        :schoolId="schoolId"
                        :timeData="$route.params.schoolId != 0?schoolTimeData:allTimeData"
                        :filters="filters"
                        :timesolt="1"
                        :contentObject="contentObject"
                        :buttonColor="'#00CAAF'"
                        @filter-data="filterData"
                ></data-filter>
            </template>
            <!-- <template slot="addFilterSlot" v-if="$route.params.schoolId!=0">
                <div>
                    <Select
                            v-model="listFilters.isActive"
                            ref="microRef"
                            filterable
                            placeholder="请选择班级状态" @on-change="selectClassStateChange">
                        <Option value="0">全部状态</Option>
                        <Option value="1">活跃</Option>
                        <Option value="2">不活跃</Option>
                    </Select>
                </div>
            </template> -->
            <template slot="buttonSlot">
                <div style="display: flex;float: right;">
                    <!--搜索框-->
                    <div class="big-data-search-input">
                        <input :placeholder="$route.params.schoolId == 0 ?'支持学校名称关键字搜索':'支持班级名称、管理员姓名关键字搜索'"
                               class="big-data-input-cla" v-model="listFilters.keyWord"
                               v-on:keyup.enter="handleSearch"/>
                        <div class="big-data-search-btn" v-on:click="handleSearch">
                            <div class="big-data-search-icon">
                                <img src="../../../../assets/images/databoard/detailPage/search.png" width="100%"
                                     height="100%"/>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </dt-search-bar>
        <div class="table-main-wrap" ref="tableMainRef">
            <div class="table-main">
                <Table :columns="$route.params.schoolId!=0?schoolClassColumn:totalClassColumn" :data="classList"
                       :row-class-name="rowClassName" :loading="isLoading"></Table>
            </div>
            <div class="bottom-page">
                <div class="laypage_main">
                    <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                          v-if="pageParams.total && pageParams.pageCount>1" show-total></Page>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {findClassList, findTotalBySchool} from "../../../../service/bigDataApi.js";

    const DtSearchBar = () => import('../../../../components/DtSearchBar');
    const DataFilter = () => import('../../../../components/DataFilter');
    export default {
        name: "class-list",
        components: {
            DtSearchBar,
            DataFilter
        },
        watch: {
            'listFilters.keyWord': {
                handler(newValue, oldValue) {
                    this.handleSearch();
                },
                deep: true
            }
        },
        data() {
            return {
                //加载中
                isLoading: true,
                //各校时间切换按钮
                schoolTimeData: [
                    {
                        key: 0,
                        value: '全部'
                    }, {
                        key: 1,
                        value: '近一周'
                    }, {
                        key: 2,
                        value: '近一月'
                    }, {
                        key: 3,
                        value: '自定义'
                    }
                ],
                //总时间切换按钮
                allTimeData: [
                    {
                        key: 0,
                        value: '全部'
                    }, {
                        key: 1,
                        value: '近一周'
                    }, {
                        key: 2,
                        value: '近一月'
                    }, {
                        key: 4,
                        value: '近三月'
                    }
                ],
                classList: [],
                schoolId: this.$route.params.schoolId == 0 ? '' : this.$route.params.schoolId,
                listFilters: {
                    isActive: "0",
                    keyWord: ''

                },
                filters: {},
                //动态配置搜索框中的组件是否显示
                contentObject: {
                    //是否显示时间切换按钮
                    displayTimeFilter: true,
                    //是否显示学科下拉框
                    displaySubjectFilter: false,
                    //是否显示年级下拉框
                    displayGradeFilter: this.$route.params.schoolId != 0 ? true : false,
                    //是否显示班级下拉框
                    displayClassFilter: this.$route.params.schoolId != 0 ? true : false,
                    //是否显示学年下拉框
                    displayYearFilter: true,
                    //是否显示省份下拉框
                    displayProvinceFilter: this.$route.params.schoolId == 0 ? true : false,
                    //是否显示城市下拉框
                    displayCityFilter: this.$route.params.schoolId == 0 ? true : false,
                    //是否显示地区下拉框
                    displayDistrictFilter: this.$route.params.schoolId == 0 ? true : false
                },
                dataDetailStyle: {
                    height: '850px'
                },
                searchHeight: {},
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                },
                //各校班级列表列
                schoolClassColumn: [
                    {
                        title: "所属年级",
                        key: "grade_name"
                    },
                    {
                        title: "班级名称",
                        key: "class_name"
                    },
                    {
                        title: "班级类型",
                        key: "clsName",
                        render: (h, params) => {
                            if (params.row.class_type === 1) {
                                return h("div", '行政班')
                            } else if (params.row.class_type === 3) {
                                return h("div", '分层班')
                            }
                        }
                    },
                    {
                        title: "班级管理员",
                        key: "leader_names",
                        render: (h, params) => {
                            if (params.row.leader_names === 0 || params.row.leader_names === "") {
                                return h("div", '暂无')
                            } else {
                                return h("div", params.row.leader_names)
                            }
                        }
                    },
                    {
                        title: "学生数量",
                        key: "stu_num",
                        renderHeader: (h, params) => {
                            return h("div",
                                {
                                    attrs: {
                                        class: "sort-col",
                                    },
                                    on: {
                                        click: () => {
                                            this.sortData('stu_num');
                                        }
                                    }
                                },
                                [
                                    h("span", {
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }, '学生数量'),
                                    h("img", {
                                        attrs: {
                                            class: "sort-fun",
                                            src: "/icon_change.png"
                                        },
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }),
                                ]);
                        }
                    },
                    {
                        title: "大屏使用天数",
                        key: "usage_day",
                        renderHeader: (h, params) => {
                            return h("div",
                                {
                                    attrs: {
                                        class: "sort-col",
                                    },
                                    on: {
                                        click: () => {
                                            this.sortData('usage_day');
                                        }
                                    }
                                },
                                [
                                    h("span", {
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }, '大屏使用天数'),
                                    h("img", {
                                        attrs: {
                                            class: "sort-fun",
                                            src: "/icon_change.png"
                                        },
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }),
                                ]);
                        },
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "点击查看大屏使用数据",
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "#0199ff",
                                            fontSize: "14px",
                                        },
                                        on: {
                                            click: () => {
                                                this.lookSchoolScreenDetails(params.row)
                                            }
                                        }
                                    },
                                    params.row.usage_day
                                )
                            ]);
                        }
                    }
                ],
                //全部学校班级列表列
                totalClassColumn: [
                    {
                        title: "省级行政区",
                        key: "province_name"
                    },
                    {
                        title: "市级行政区",
                        key: "city_name"
                    },
                    {
                        title: "所属区域",
                        key: "district_name"
                    },
                    {
                        title: "学校名称",
                        key: "school_name",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "点击查看各校数据展板",
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "#0199ff",
                                            fontSize: "14px",
                                        },
                                        on: {
                                            click: () => {
                                                this.lookSchoolDataBoard(params.row)
                                            }
                                        }
                                    },
                                    params.row.school_name
                                )
                            ]);
                        }
                    },
                    {
                        title: "使用班级数",
                        key: "use_class_num",
                        renderHeader: (h, params) => {
                            return h("div",
                                {
                                    attrs: {
                                        class: "sort-col",
                                    },
                                    on: {
                                        click: () => {
                                            this.sortData('use_class_num');
                                        }
                                    }
                                },
                                [
                                    h("span", {
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }, '使用班级数'),
                                    h("img", {
                                        attrs: {
                                            class: "sort-fun",
                                            src: "/icon_change.png"
                                        },
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }),
                                ]);
                        }
                    },
                    {
                        title: "班级总数",
                        key: "class_num",
                        renderHeader: (h, params) => {
                            return h("div",
                                {
                                    attrs: {
                                        class: "sort-col",
                                    },
                                    on: {
                                        click: () => {
                                            this.sortData('class_num');
                                        }
                                    }
                                },
                                [
                                    h("span", {
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }, '班级总数'),
                                    h("img", {
                                        attrs: {
                                            class: "sort-fun",
                                            src: "/icon_change.png"
                                        },
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }),
                                ]);
                        }
                    }
                ],
                //各校班级列表排序参数
                schoolClassDataSortArr: [
                    {
                        sortType: 'stu_num',
                        orderType: 'desc'
                    },
                    {
                        sortType: 'usage_day',
                        orderType: 'desc'
                    }
                ],
                //全部班级列表排序参数
                tolClassDataSortArr: [
                    {
                        sortType: 'use_class_num',
                        orderType: 'desc'
                    },
                    {
                        sortType: 'class_num',
                        orderType: 'desc'
                    }
                ],
                schoolClassDataOrder: 'stu_num desc',
                tolClassDataOrder: 'use_class_num desc'
            }
        },
        created() {
            let currentPathArr;
            currentPathArr = [
                {
                    title: "首页",
                    path: this.$route.params.schoolId=='75047a8a0990480f8abf3a39bc25f1ab'?'cloudschooldataboard':"schooldataboard",
                    name: this.$route.params.schoolId=='75047a8a0990480f8abf3a39bc25f1ab'?'cloudschooldataboard':"schooldataboard",
                    params: {
                        schoolId: this.$route.params.schoolId,
                    },query:{
                        tokenId:this.$store.getters.token
                    }
                },
                {
                    title: this.$route.params.schoolName,
                    path: "",
                    name: "schoolName"
                },
                {
                    title: "全部班级",
                    path: "",
                    name: "classList"
                }
            ];
            this.$store.commit("setCurrentPath", currentPathArr);
        },
        methods: {
            /**
             * 筛选数据
             */
            filterData(filters, searchHeight) {
                this.pageParams.page = 1;
                // this.listFilters.keyWord = "";
                this.isLoading = true;
                this.filters = filters;
                this.searchHeight = searchHeight;
                this.queryClassDataBySchoolCode();
            },
            /**
             * 选择班级状态
             */
            selectClassStateChange(val) {
                this.pageParams.page = 1;
                this.listFilters.keyWord = "";
                this.isLoading = true;
                this.filters.isActive = val == undefined || val == "" ? "0" : val;
                this.queryClassDataBySchoolCode();
            },
            /**
             * 点击进入查看大屏
             */
            lookSchoolScreenDetails(rows) {
                if(rows.disk_id){
                    let routeData = this.$router.resolve({
                        name: "scrUserDetai",
                        query: {
                            schoolId: this.schoolId,
                            selfStartDate: this.filters.startDate,
                            selfEndDate: this.filters.endDate,
                            parentalStartDate:this.filters.startDate,
                            parentalEndDate:  this.filters.endDate,
                            schoolName:this.$route.params.schoolName,
                            diskId: rows.disk_id,
                            type:'bigData'
                        }
                    });
                    window.open(routeData.href, "_blank");
                }

            },
            /**
             * 查看各校的数据展板
             */
            lookSchoolDataBoard(rows) {
                let routeData = this.$router.resolve({
                    name: rows.school_id=='75047a8a0990480f8abf3a39bc25f1ab'?'cloudschooldataboard':"schooldataboard",
                    params: {
                        schoolId: rows.school_id
                    },query:{
                        tokenId:this.$store.getters.token
                    }
                });
                window.open(routeData.href, "_blank");
            },
            /**
             * 获取班级列表
             */
            async getClassList() {
                let _this = this;
                let params = {
                    schoolid: _this.schoolId,
                    keyword: _this.listFilters.keyWord,
                    startdate: _this.filters.startDate,
                    enddate: _this.filters.endDate,
                    schoolyear: _this.filters.classyear,
                    pageno: _this.pageParams.page,
                    pagesize: _this.pageParams.limit,
                    gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
                    classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
                    isactive: _this.listFilters.isActive,
                    order: _this.schoolClassDataOrder,
                    timeType:_this.filters.timeSolt,
                };
                let resultData = await findClassList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.isLoading = false;
                _this.classList = [];
                _this.pageParams.total = 0;
                if (Object.keys(resultData).length > 0) {
                    _this.classList = resultData.rows;
                    _this.pageParams.total = resultData.total_rows;
                    _this.pageParams.pageCount = resultData.page_count;
                    _this.$nextTick(() => {
                        _this.dataDetailStyle.height = _this.searchHeight + _this.$refs.tableMainRef.clientHeight + 30 + 'px';
                    })
                }
            },
            /**
             * 获取总班级列表
             */
            async getTotalBySchool() {
                let _this = this;
                let params = {
                    schoolid: _this.schoolId,
                    keyword: _this.listFilters.keyWord,
                    pageno: _this.pageParams.page,
                    pagesize: _this.pageParams.limit,
                    type: _this.filters.timeSolt == 4 ? 3 : _this.filters.timeSolt == 0 ? '' : _this.filters.timeSolt,
                    provinceId: _this.filters.provinceId == '0' ? "" : _this.filters.provinceId,
                    cityId: _this.filters.cityId == '0' ? "" : _this.filters.cityId,
                    districtId: _this.filters.districtId == '0' ? "" : _this.filters.districtId,
                    order: _this.tolClassDataOrder
                };
                let resultData = await findTotalBySchool(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.isLoading = false;
                _this.classList = [];
                _this.pageParams.total = 0;
                if (Object.keys(resultData).length > 0) {
                    _this.classList = resultData.rows;
                    _this.pageParams.total = resultData.total_rows;
                    _this.pageParams.pageCount = resultData.page_count;
                    _this.$nextTick(() => {
                        _this.dataDetailStyle.height = _this.searchHeight + _this.$refs.tableMainRef.clientHeight + 30 + 'px';
                    })
                }
            },
            /**
             * 翻页
             */
            handleCurrentChange(val) {
                this.isLoading = true;
                this.pageParams.page = val;
                this.queryClassDataBySchoolCode();
            },
            /**
             * 查询
             */
            handleSearch() {
                this.isLoading = true;
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.queryClassDataBySchoolCode();
            },
            /**
             * 排序
             */
            sortData(sortType) {
                let data = [];
                if (this.$route.params.schoolId != 0) {
                    data = this.schoolClassDataSortArr
                } else {
                    data = this.tolClassDataSortArr
                }
                for (let i = 0; i < data.length; i++) {
                    if (data[i].sortType == sortType) {
                        data[i].orderType = data[i].orderType == 'desc' ? 'asc' : 'desc';
                        if (this.$route.params.schoolId != 0) {
                            this.schoolClassDataOrder = data[i].sortType + ' ' + data[i].orderType;
                        } else {
                            this.tolClassDataOrder = data[i].sortType + ' ' + data[i].orderType;
                        }
                    }
                }
                this.pageParams.page = 1;
                this.queryClassDataBySchoolCode();
            },
            /**
             * 表格斑马纹
             */
            rowClassName(row, index) {
                if (index % 2 == 0) {
                    return 'ivu-table-stripe-even';
                } else return 'ivu-table-stripe-odd';
            },
            /**
             * 根据情况请求不同的班级列表数据
             */
            queryClassDataBySchoolCode() {
                if (this.$route.params.schoolId != 0) {
                    this.getClassList();
                } else {
                    this.getTotalBySchool();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/detailPage";

    .big-data-search-btn {
        background: #00CAAF !important;
        color: #fff;
        border-color: #00CAAF !important;
    }

    .table-main-wrap {
        margin-top: 10px !important;
    }
</style>
<style lang="scss">
    .table-main {
        /*偶数行*/
        .ivu-table-stripe-even td {
            background-color: #fff !important;
        }

        /*奇数行*/
        .ivu-table-stripe-odd td {
            background-color: #fafbfd !important;
        }

        .ivu-table th {
            background-color: #f3f7f6;
            height: 50px !important;
            font-weight: bold;
        }
        .ivu-table td, .ivu-table th {
            border-bottom: 0;
        }
        .ivu-table:before {
            background-color: #efefef !important;
        }
        .ivu-table:after {
            background-color: #efefef !important;
        }
        .ivu-table-wrapper {
            border-top: 1px solid #efefef;
            border-left: 1px solid #efefef;
        }
    }
</style>
